<section class="chatbot-shell" aria-label="Talk to your data workspace">
  <button class="chatbot-shell__sidebar-toggle" type="button" (click)="toggleSidebar()">
    <cwc-icon [name]="sidebarVisible ? 'close' : 'menu'" color="white"></cwc-icon>
  </button>

  <talk-to-your-data-sidebar
    class="chatbot-shell__sidebar"
    [class.chatbot-shell__sidebar--hidden]="!sidebarVisible"
    [conversationHistory]="conversationHistory || []"
    [savedConversations]="savedConversations || []"
    [quickQuestions]="quickQuestions || []"
    [selectedConversationId]="selectedConversationId"
    [userProfile]="userProfile"
    (conversationSelected)="onConversationSelected($event)"
    (conversationSaved)="conversationSaved.emit($event)"
    (conversationUnsaved)="conversationUnsaved.emit($event)"
    (conversationRenamed)="conversationRenamed.emit($event)"
    (conversationDeleted)="conversationDeleted.emit($event)"
    (quickQuestionSelected)="onSuggestionSelected($event)"
    (newChatSelected)="onNewChat()"
  ></talk-to-your-data-sidebar>
  <div class="chatbot-shell__main">
    <main
      class="chatbot-shell__content"
      data-testid="chatbot-shell-content"
      [class.chatbot-shell__content--welcome]="isWelcomeState"
      aria-live="polite"
    >
      <talk-to-your-data-welcome-panel
        *ngIf="isWelcomeState"
        [quickQuestions]="quickQuestions || []"
        (suggestionSelected)="onSuggestionSelected($event)"
      ></talk-to-your-data-welcome-panel>
      <talk-to-your-data-conversation-panel
        *ngIf="!isWelcomeState"
        [activeConversation]="activeConversation"
        [loading]="loading"
        [error]="error"
      ></talk-to-your-data-conversation-panel>
    </main>
    <footer class="chatbot-shell__input" aria-label="Message input area">
      <talk-to-your-data-message-input
        [focusTrigger]="focusInputTrigger"
        [disabled]="!!sendingMessage"
        (messageSubmitted)="onMessageSubmitted($event)"
        (stopRequested)="onStopRequested()"
      ></talk-to-your-data-message-input>
    </footer>
  </div>
</section>
